import { Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { Recommendation } from "@labs/shared/types/Recommendation.ts";
import { Link } from "react-router";

type RecommendationsListProps = {
  recommendations: Recommendation[];
};

export const RecommendationsList = ({
  recommendations,
}: RecommendationsListProps) => (
  <Stack
    sx={{
      maxHeight: "540px",
      overflowY: "scroll",
    }}
    spacing={2}
  >
    <Typography variant="h6" color={"primary.dark"}>
      Cascade Recommendations
    </Typography>

    <Stack direction="column" spacing={2} sx={{ padding: 1 }}>
      {recommendations.map((recommendation) => (
        <Card
          key={recommendation.id}
          sx={{
            padding: 1,
          }}
        >
          <CardContent>
            <Stack spacing={1}>
              <Typography variant={"body1"}>{recommendation.title}</Typography>
              <Typography variant={"body2"}>
                {recommendation.description}
              </Typography>
              <Button
                variant={"contained"}
                component={Link}
                to={recommendation.href}
                sx={{ alignSelf: "flex-start" }}
              >
                Adjust your plan
              </Button>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Stack>
  </Stack>
);
